import {
  Ship,
  Stamp,
  FlaskConical,
  Wrench,
  Receipt,
} from "lucide-react";

export type CostType = "freight" | "customs" | "sampling" | "mould" | "other";

export const COST_TYPE_OPTIONS: { value: CostType; label: string; icon: typeof Ship; color: string }[] = [
  { value: "freight", label: "Freight", icon: Ship, color: "text-blue-500" },
  { value: "customs", label: "Customs", icon: Stamp, color: "text-amber-600" },
  { value: "sampling", label: "Sampling", icon: FlaskConical, color: "text-violet-500" },
  { value: "mould", label: "Mould Fee", icon: Wrench, color: "text-slate-500" },
  { value: "other", label: "Other", icon: Receipt, color: "text-emerald-500" },
];

export const getCostTypeLabel = (costType: string): string =>
  COST_TYPE_OPTIONS.find((o) => o.value === costType)?.label ?? costType;

export const getCostTypeIcon = (costType: string) =>
  COST_TYPE_OPTIONS.find((o) => o.value === costType)?.icon ?? Receipt;

export const getCostTypeColor = (costType: string): string =>
  COST_TYPE_OPTIONS.find((o) => o.value === costType)?.color ?? "text-muted-foreground";
